<template>
  <ButtonAction class="button" @click="handleShare">
    <template #icon>
      <Icon name="quizShare" />
    </template>
    {{ $t('exercise.button.share') }}
  </ButtonAction>
</template>
<script lang="ts" setup>
interface Props {
  category: CategorySchema;
  score: number;
  title: string;
}

const props = defineProps({
  category: null,
  score: null,
  title: null
});

const appEventShare = useAppEventShare(
  EventAssociatedModel.Share,
  props.category.id,
  'exercise',
  'resultExercise',
  props.category.disciplineId,
  props.category.parentId,
  props.category.contentType
);

const { handleShare } = useShareExercise(
  props.score,
  props.title,
  appEventShare
);
</script>
<style lang="scss" scoped>
.button {
  width: 100%;
  height: 100%;
}
</style>
